import { createSelector } from 'reselect';
import { UIFilterCampaignKindType } from '../model/CampaignOverviewModel';
import { CampaignsOverviewStateType } from '../reducers/campaignsOverview';
import { StoreState } from '../store-interfaces';

const selectCampaignsOverviewState = (state: StoreState) =>
  state.campaignsOverview;

const selectUIFilterKind = (_: StoreState, kind: UIFilterCampaignKindType) =>
  kind;

const getRecordsByUiFilterKind = (
  records: CampaignsOverviewStateType,
  kind?: UIFilterCampaignKindType,
) => {
  const kindToGet = kind || 'all';
  return records.records[kindToGet];
};

export const selectInvalidRecords = createSelector(
  [selectCampaignsOverviewState],
  records => records.invalidRecords,
);

export const selectRecordsByUiFilterKind = createSelector(
  [selectCampaignsOverviewState, selectUIFilterKind],
  getRecordsByUiFilterKind,
);

export const selectOverviewCountByUiFilterKind = (
  state: StoreState,
  kind: UIFilterCampaignKindType,
) => {
  const recordByKind = selectRecordsByUiFilterKind(state, kind);

  const countByKind = recordByKind?.pagination?.total;
  const count: number | undefined = state?.campaignsOverview?.counters?.[kind];

  return count || countByKind;
};
